// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-feedback-panel {
  max-width: 640px;
  padding: 2rem 2.2rem 1.9rem;
  position: relative;
}

/* Full-session feedback is portalled to document.body. Keep the theme scope
   without allowing the synthetic App wrapper to become a layout container. */
.full-session-feedback-portal {
  position: static;
  display: block;
  width: 0;
  height: 0;
  overflow: visible;
}

.app-feedback-panel .app-dialog-title {
  font-size: 1.06rem;
}

.app-feedback-panel .app-confirm-content {
  font-size: 0.92rem;
  line-height: 1.55;
}

.app-feedback-actions {
  justify-content: flex-end;
}

.app-feedback-actions .app-confirm-btn {
  padding: 0.4rem 1rem;
  min-width: 86px;
  font-size: 0.82rem;
}

.app-feedback-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.2rem;
}

.app-feedback-field-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: baseline;
  column-gap: 0.75rem;
}

.app-feedback-question {
  gap: 0.75rem;
  padding: 0;
}

.app-feedback-question-text {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.5;
  font-weight: 600;
  color: #1e293b;
}

.app-feedback-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
}

.app-feedback-input {
  width: 100%;
  min-height: 7.5rem;
  resize: none;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 12px;
  padding: 0.75rem 0.9rem;
  font: inherit;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #0f172a;
  background: #f8fafc;
  box-sizing: border-box;
  overflow-y: auto;
}

.app-feedback-word-count {
  align-self: flex-start;
  margin-top: 0.15rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.2;
  color: #64748b;
}

.app-feedback-input::placeholder {
  color: #94a3b8;
}

.app-feedback-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.app-likert-scale {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.32rem;
  padding: 0.18rem;
  border-radius: 999px;
  background: rgba(226, 232, 240, 0.7);
}

.app-likert-option {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 1.75rem;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
}

.app-likert-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.app-likert-option span {
  font-size: 0.76rem;
  font-weight: 700;
  color: #334155;
}

.app-likert-option.active {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.16);
}

.app-likert-option.active span {
  color: #1d4ed8;
}

.app-likert-scale-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.68rem;
  color: #64748b;
  padding: 0 0.1rem;
  margin-top: 0.1rem;
}

.App.dark .app-feedback-label {
  color: #cbd5e1;
}

.App.dark .app-feedback-question {
  background: transparent;
}

.App.dark .app-feedback-question-text {
  color: #e2e8f0;
}

.App.dark .app-feedback-input {
  border-color: rgba(148, 163, 184, 0.3);
  color: #e2e8f0;
  background: #1c2630;
}

.App.dark .app-feedback-input::placeholder {
  color: #64748b;
}

.App.dark .app-feedback-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);
}

.App.dark .app-feedback-word-count {
  color: #94a3b8;
}

.App.dark .app-likert-option {
  border-color: transparent;
  background: transparent;
}

.App.dark .app-likert-option span {
  color: #cbd5e1;
}

.App.dark .app-likert-option.active {
  border-color: #60a5fa;
  background: #1c2630;
  box-shadow: 0 2px 8px rgba(96, 165, 250, 0.16);
}

.App.dark .app-likert-option.active span {
  color: #93c5fd;
}

.App.dark .app-likert-scale-labels {
  color: #94a3b8;
}

.App.dark .app-likert-scale {
  background: rgba(15, 23, 42, 0.65);
}

.app-feedback-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.app-feedback-close svg {
  width: 1rem;
  height: 1rem;
}

.app-feedback-close:hover {
  background: rgba(148, 163, 184, 0.16);
  color: #0f172a;
}

.App.dark .app-feedback-close {
  color: #94a3b8;
}

.App.dark .app-feedback-close:hover {
  background: rgba(148, 163, 184, 0.14);
  color: #f8fafc;
}

.app-feedback-overlay {
  align-items: center;
  padding-top: 1.5rem;
  /* Feedback dialogs are rendered from inside report/sidebar stacking
     contexts. Keep them above the persistent AIMIE header, composer, virtual
     keyboard, and single-column overlay shell. */
  z-index: 70000;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/FeedbackDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;6EAC6E;AAC7E;EACE,gBAAgB;EAChB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB;;iDAE+C;EAC/C,cAAc;AAChB","sourcesContent":[".app-feedback-panel {\n  max-width: 640px;\n  padding: 2rem 2.2rem 1.9rem;\n  position: relative;\n}\n\n/* Full-session feedback is portalled to document.body. Keep the theme scope\n   without allowing the synthetic App wrapper to become a layout container. */\n.full-session-feedback-portal {\n  position: static;\n  display: block;\n  width: 0;\n  height: 0;\n  overflow: visible;\n}\n\n.app-feedback-panel .app-dialog-title {\n  font-size: 1.06rem;\n}\n\n.app-feedback-panel .app-confirm-content {\n  font-size: 0.92rem;\n  line-height: 1.55;\n}\n\n.app-feedback-actions {\n  justify-content: flex-end;\n}\n\n.app-feedback-actions .app-confirm-btn {\n  padding: 0.4rem 1rem;\n  min-width: 86px;\n  font-size: 0.82rem;\n}\n\n.app-feedback-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1.2rem;\n}\n\n.app-feedback-field-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: baseline;\n  column-gap: 0.75rem;\n}\n\n.app-feedback-question {\n  gap: 0.75rem;\n  padding: 0;\n}\n\n.app-feedback-question-text {\n  margin: 0;\n  font-size: 0.86rem;\n  line-height: 1.5;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.app-feedback-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.app-feedback-input {\n  width: 100%;\n  min-height: 7.5rem;\n  resize: none;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  border-radius: 12px;\n  padding: 0.75rem 0.9rem;\n  font: inherit;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: #0f172a;\n  background: #f8fafc;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.app-feedback-word-count {\n  align-self: flex-start;\n  margin-top: 0.15rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: #64748b;\n}\n\n.app-feedback-input::placeholder {\n  color: #94a3b8;\n}\n\n.app-feedback-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.app-likert-scale {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.32rem;\n  padding: 0.18rem;\n  border-radius: 999px;\n  background: rgba(226, 232, 240, 0.7);\n}\n\n.app-likert-option {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1.75rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background: transparent;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n}\n\n.app-likert-option input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.app-likert-option span {\n  font-size: 0.76rem;\n  font-weight: 700;\n  color: #334155;\n}\n\n.app-likert-option.active {\n  border-color: #2563eb;\n  background: #ffffff;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.16);\n}\n\n.app-likert-option.active span {\n  color: #1d4ed8;\n}\n\n.app-likert-scale-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.68rem;\n  color: #64748b;\n  padding: 0 0.1rem;\n  margin-top: 0.1rem;\n}\n\n.App.dark .app-feedback-label {\n  color: #cbd5e1;\n}\n\n.App.dark .app-feedback-question {\n  background: transparent;\n}\n\n.App.dark .app-feedback-question-text {\n  color: #e2e8f0;\n}\n\n.App.dark .app-feedback-input {\n  border-color: rgba(148, 163, 184, 0.3);\n  color: #e2e8f0;\n  background: #1c2630;\n}\n\n.App.dark .app-feedback-input::placeholder {\n  color: #64748b;\n}\n\n.App.dark .app-feedback-input:focus {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);\n}\n\n.App.dark .app-feedback-word-count {\n  color: #94a3b8;\n}\n\n.App.dark .app-likert-option {\n  border-color: transparent;\n  background: transparent;\n}\n\n.App.dark .app-likert-option span {\n  color: #cbd5e1;\n}\n\n.App.dark .app-likert-option.active {\n  border-color: #60a5fa;\n  background: #1c2630;\n  box-shadow: 0 2px 8px rgba(96, 165, 250, 0.16);\n}\n\n.App.dark .app-likert-option.active span {\n  color: #93c5fd;\n}\n\n.App.dark .app-likert-scale-labels {\n  color: #94a3b8;\n}\n\n.App.dark .app-likert-scale {\n  background: rgba(15, 23, 42, 0.65);\n}\n\n.app-feedback-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.app-feedback-close svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.app-feedback-close:hover {\n  background: rgba(148, 163, 184, 0.16);\n  color: #0f172a;\n}\n\n.App.dark .app-feedback-close {\n  color: #94a3b8;\n}\n\n.App.dark .app-feedback-close:hover {\n  background: rgba(148, 163, 184, 0.14);\n  color: #f8fafc;\n}\n\n.app-feedback-overlay {\n  align-items: center;\n  padding-top: 1.5rem;\n  /* Feedback dialogs are rendered from inside report/sidebar stacking\n     contexts. Keep them above the persistent AIMIE header, composer, virtual\n     keyboard, and single-column overlay shell. */\n  z-index: 70000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
